import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CtaButton } from './ui/CtaButton';
export function HeroSection() {
  return <section className="relative w-full overflow-hidden pt-12 pb-6 md:pt-20 md:pb-8 px-4 md:px-6" data-id="element-89">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-90">
        {/* Top Headline */}
        <FadeIn data-id="element-91">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white" data-id="element-92">
            Tu problema no es la crisis. <br data-id="element-93" />
            <span className="text-brand-gold" data-id="element-94">Es tu dinero sin reglas.</span>
          </h1>
        </FadeIn>

        {/* Subtitle */}
        <FadeIn delay={0.1} data-id="element-95">
          <p className="text-lg md:text-xl text-brand-muted mb-8 max-w-2xl" data-id="element-96">
            MANUAL DEL DINERO — Cómo protegerte cuando EE.UU. tiembla y
            Latinoamérica lo siente más fuerte
          </p>
        </FadeIn>

        {/* CTA above image */}
        <FadeIn delay={0.15} className="mb-10 w-full flex justify-center" data-id="element-97">
          <CtaButton onClick={() => document.getElementById('final-cta')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-98">
            Quiero el Manual del Dinero
          </CtaButton>
        </FadeIn>

        {/* Cover Image */}
        <FadeIn delay={0.2} className="mb-12 w-full flex justify-center" data-id="element-99">
          <div className="relative group" data-id="element-100">
            <div className="absolute -inset-1 bg-brand-gold/20 blur-xl rounded-lg opacity-50 group-hover:opacity-75 transition duration-500" data-id="element-101"></div>
            <img src="https://cdn.magicpatterns.com/uploads/9KH9NX2Caw88APMuyTmcMh/Manual_del_Dinero.png" alt="Portada del Manual del Dinero" className="relative w-full max-w-[300px] md:max-w-[400px] shadow-2xl rounded-sm border border-brand-card" data-id="element-102" />
          </div>
        </FadeIn>

        {/* Opening Lead */}
        <FadeIn delay={0.3} className="text-left w-full max-w-2xl space-y-6 text-lg md:text-xl leading-relaxed text-brand-text/90 mb-12" data-id="element-103">
          <p data-id="element-104">
            Si emprendes en Latinoamérica, hay un tipo de cansancio que no se
            ve.
          </p>
          <p data-id="element-105">
            No es el cansancio de trabajar. Es el cansancio de{' '}
            <strong className="text-white font-semibold" data-id="element-106">
              no sentirte seguro
            </strong>
            , aunque estés "haciendo todo".
          </p>
          <p data-id="element-107">
            Porque basta con que se mueva el dólar. Basta con que suban tasas.
            Basta con que el mercado se ponga nervioso…
          </p>
          <p data-id="element-108">…para que tu cabeza empiece a negociar con tu dinero.</p>
          <p data-id="element-109">
            Y ahí pasa lo de siempre: mueves plata para calmar ansiedad, no para
            construir estabilidad.
          </p>
          <div className="border-l-4 border-brand-gold pl-6 py-2 my-8 bg-brand-card/50" data-id="element-110">
            <p className="font-serif text-xl md:text-2xl text-white italic" data-id="element-111">
              La crisis no destruye tu dinero.
              <br data-id="element-112" />
              Tu dinero sin reglas destruye tu estabilidad.
            </p>
          </div>
        </FadeIn>

        {/* CTA Block */}
        <FadeIn delay={0.4} className="flex flex-col items-center gap-4 w-full max-w-md" data-id="element-113">
          <div className="flex items-center gap-3" data-id="element-114">
            <span className="text-brand-muted line-through text-base" data-id="element-115">
              US$19
            </span>
            <span className="text-brand-gold font-semibold tracking-wide text-lg" data-id="element-116">
              US$6.39
            </span>
            <span className="bg-brand-gold text-brand-bg text-xs font-bold px-2 py-1 rounded" data-id="element-117">
              78% OFF
            </span>
          </div>
          <div className="text-brand-muted text-sm uppercase tracking-wide" data-id="element-118">
            Acceso inmediato
          </div>
          <CtaButton fullWidth onClick={() => document.getElementById('final-cta')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-119">
            Descárgalo ahora
          </CtaButton>
          <p className="text-xs text-brand-muted mt-2" data-id="element-120">
            Formato ebook + Plantillas + Plan Accionable
          </p>
        </FadeIn>
      </div>
    </section>;
}